export enum UserStatusEnum {
    ENABLED = 'ena',
    DISABLED = 'dis',
    VERIFICATION = 'ver'
}
